import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './http'

import '@/assets/app.css'

Vue.config.productionTip = false
Vue.prototype.$http = axios

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

if (process.env.VUE_APP_ENABLE_TAILWIND_DEBUG_SCREENS === 'true') {
  document.body.classList.add('debug-screens')
}
